import React, { useState, useEffect } from "react";
import CountRenderer from "./CountRenderer";
import { uepClient } from "uepClient";
import BrochureSummaryService from "services/BrochureSummaryService";
import WithAlert from "hoc/WithAlert";

function BrochuresSummary(props) {
  const [brochureCounts, setBrochureCounts] = useState({
    salesCount: 0,
    serviceCount: 0,
  });

  const fetchBrochureCounts = () => {
    uepClient()
      .get("/file-info/count")
      .then((res) => {
        const brochuresCount = res.data;
        setBrochureCounts({
          salesCount: brochuresCount.salesCount,
          serviceCount: brochuresCount.serviceCount,
        });
      })
      .catch((err) => {
        props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to fetch the data for brochure summary.
            </span>
          ),
        });
        console.error(err.message);
      });
  };

  useEffect(() => {
    const brochureSummarySubscription = BrochureSummaryService.listen().subscribe(
      fetchBrochureCounts
    );
    fetchBrochureCounts();
    return () => {
      brochureSummarySubscription.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="admin-tab-content brochures-summary-content">
      <CountRenderer label="Sales" count={brochureCounts.salesCount} />
      <CountRenderer label="Service" count={brochureCounts.serviceCount} />
    </div>
  );
}

const brochureSummaryWithAlert = WithAlert(BrochuresSummary);

export default brochureSummaryWithAlert;
